// src/components/ClientPortalCommunicationLogs.js

import React from 'react';

function ClientPortalCommunicationLogs({ currentUser, clients, communicationLogs, cases }) {
  // Find the specific client profile linked to the current user
  const clientProfile = clients.find(client => client.user === currentUser.id);

  // Filter communication logs relevant to this specific client profile or their cases
  const clientCommunicationLogs = communicationLogs.filter(log =>
    log.client === (clientProfile ? clientProfile.id : null) ||
    (log.case && cases.some(c => c.id === log.case && c.client === (clientProfile ? clientProfile.id : null)))
  );

  return (
    <div>
      <h2 className="text-2xl font-bold text-primary mb-1">Your Communication Logs</h2>
      {clientProfile ? (
        <p className="text-gray-500 mb-6">Review your communication history with the firm, {clientProfile.first_name} {clientProfile.last_name}.</p>
      ) : (
        <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6">
          <p className="text-yellow-700">Your user account is not yet linked to a client profile. Please contact the firm administrator to view your communication logs.</p>
        </div>
      )}

      {clientCommunicationLogs.length > 0 ? (
        <div className="bg-white rounded-lg shadow border border-gray-200 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full">
              <thead className="bg-primary text-white">
                <tr>
                  <th className="px-4 py-3 text-left text-sm font-semibold">Date</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold">Type</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold">Summary</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold">Associated Case</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold">Logged By</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {(clientCommunicationLogs || []).map(log => (
                  <tr key={log.id} className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm text-gray-600">{new Date(log.communication_date).toLocaleDateString()}</td>
                    <td className="px-4 py-3 text-sm text-gray-600">{log.log_type}</td>
                    <td className="px-4 py-3 text-sm text-gray-800">{log.summary}</td>
                    <td className="px-4 py-3 text-sm text-gray-600">{log.case_title || 'N/A'}</td>
                    <td className="px-4 py-3 text-sm text-gray-600">{log.logged_by_username || 'N/A'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 text-center">
          <p className="text-blue-700">No communication logs found associated with your client profile or cases.</p>
        </div>
      )}
    </div>
  );
}

export default ClientPortalCommunicationLogs;
